<template>
    <div class="calendar-page">
        <app-loading 
            v-if="loading"
        />

        <transition 
            name="fade-overlay" 
            appear
            mode="out-in"
        >
            <app-calendar-popup
                v-if="is_weather"
                @clickPopupButton="clickPopupButton"
            />

        </transition>

        <transition 
            name="fade-overlay" 
            appear
            mode="out-in"
        >
            <app-calendar-popup-time
                v-if="is_select_time"
                :day="day"
                :dayInfo="dayInfo"
                :name="name"
                :times="times"
                :price="price"
                :priceWeekend="priceWeekend"
                :priceHolidays="priceHolidays"
                :pricePrimeTime="pricePrimeTime"
                @clickOkTime="clickOkTime"
                @clickClosePopup="clickClosePopup"
                @clickClosePopupMobile="clickClosePopupMobile"
            />
        </transition>

        <app-header 
            :position="'fixed'"
            :top="'0px'"
            :background="'transparent'"
            @clickBack="$router.push('/final')"
            @clickMenu="change_menu(context, true)"
        />

        <transition 
            name="fade-overlay" 
            appear
            mode="out-in"
        >

            <div class="calendar-page__calendar-wrapper"
                v-if="statusCalendar"
            >
                
                <app-calendar 
                    v-for="(item, index) in calendar"
                    :key="item.id"
                    :index="index"
                    :title="item.title"
                    :month="item.month"
                    :year="item.year"
                    :days="item.days"
                    @clickDate="clickDate"
                />

            </div>

        </transition>

        <transition 
            name="fade-menu" 
            appear
            mode="out-in"
        >
            <app-menu 
                v-if="menu"
                idLogoMenu="header-component__menu"
                @clickLink="change_menu(context, false)"
                @clickOutside="change_menu(context, false)"
            />
        </transition >
        
        <transition 
            name="fade-overlay" 
            appear
            mode="out-in"
        >
            <app-overlay 
                v-if="overlay"
            />
        </transition>

      <transition
          name="fade-overlay"
          appear
          mode="out-in"
      >

        <app-alert
            v-if="error.status"
            buttonText="Вернуться на главную"
            :text="error.text"
            @clickGrowButtonPopup="$router.push('/')"
        />

      </transition>
    </div>
</template>

<script>

    const AppLoading = () => import('@/components/loading.vue')
    const AppHeader = () => import('@/components/header.vue')
    const AppMenu = () => import('@/components/menu.vue')
    const AppOverlay = () => import('@/components/overlay.vue')
    const AppCalendar = () => import('@/components/calendar.vue')
    const AppCalendarPopup = () => import('@/components/popups/calendar-popup.vue')
    const AppCalendarPopupTime = () => import('@/components/popups/calendar-popup-time.vue')
    const AppAlert = () => import('@/components/popups/error')

    import calendar_get from "@/views/calendar/modules/calendar_get";
    import change_menu from "@/views/theme/modules/change_menu";

    export default {
        async mounted() {
          await this.calendar_get(this)
        },
        data() {
            return {
                context: this,
                menu: false,
                overlay: false,
                rendering: false,
                watchCalendar: false,
                statusCalendar: false,
                is_weather: false,
                is_select_time: false,
                calendar: [],
                error: {
                  status: false,
                  text: ''
                }
            }
        },
        components: {
            AppLoading,
            AppHeader,
            AppMenu,
            AppOverlay,
            AppCalendar,
            AppCalendarPopup,
            AppCalendarPopupTime,
            AppAlert
        },
        methods: {
          calendar_get,
          change_menu,
            async clickPopupButton() {
                this.overlay = false
                this.is_weather = false
            },
            async clickOkTime() {
                this.overlay = false
                this.is_select_time = false
                this.$router.push('/auth')
            },
            async clickDate() {
                this.overlay = true
                this.is_select_time = true
            },
            async clickClosePopup() {
                this.overlay = false
                this.is_select_time = false
            },
            async clickClosePopupMobile() {
                let width = document.documentElement.clientWidth
                if(width < 778) {
                    this.clickClosePopup()
                }
            }
        },
        computed: {
            loading() {
              return !(this.rendering && this.calendar.length > 0)
            },
            day(){
                return this.$store.getters['date/day']
            },
            dayInfo() {
                return this.$store.getters['date/dayInfo']
            },
            name() {
                return this.$store.getters['date/name']
            },
            times() {
                return this.$store.getters['date/times']
            },
            price() {
                return this.$store.getters['price/priceMusic'].value
            },
            priceWeekend() {
                return this.$store.getters['settings/priceWeekend']
            },
            priceHolidays() {
                return this.$store.getters['settings/priceHolidays']
            },
            pricePrimeTime() {
                return this.$store.getters['settings/pricePrimeTime']
            },
        }
    }
</script>

<style lang="less">
    .calendar-page {
        background-color: #2F1F4C;
        width: 100%;
        min-height: calc(var(--vh, 1vh) * 100);
        display: flex;
        align-items: center;
        flex-direction: column;
    }

    .calendar-page__calendar-wrapper {
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 100%;
    }

    .calendar-page__calendar-wrapper:last-child {
        margin-bottom: 60px;
    }

    @import '~/assets/fonts/montserrat/Montserrat-Bold.less';
    @import '~/assets/fonts/roboto/Roboto-Light.less';
    @import '~/assets/fonts/montserrat/Montserrat-Medium.less';
    @import '~/assets/fonts/roboto/Roboto-Medium.less';

</style>